module.exports = __webpack_public_path__ + "img/preview-11.ff0a0d33.png";